import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAdmin: false,
    adminRights: {
        settings: false,
        createBranches: false,
    },
};

const userRightsSlice = createSlice({
    name: 'userRights',
    initialState,
    reducers: {},
});

export default userRightsSlice.reducer;
